import { styled } from '@mui/material'
import { Button } from './Button'

export const FloatingButton = styled(Button)`
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
`
